import { Box, Button, Stack, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { createPDF } from 'utils/createPDF';
import { downloadBlobFile } from 'utils/Utils';
/**
 * @description
 * This component is used to render a confirmation dialog box when a user's resume is downloaded after
 * applying to a job. It has two buttons - "Do It Later" and "Continue with Application".
 * The "Do It Later" button closes the dialog box and allows the user to continue using the app.
 * The "Continue with Application" button redirects the user to the external job application platform.
 * The button is disabled while the application is in progress and displays "In-progress..."
 * @param {function} onClose - Function to close the dialog box.
 * @param {function} handleContinueExternalApplication - Function to redirect to the external job application platform.
 * @param {boolean} isSubmitting - Whether the job application is in progress.
 * @returns {JSX.Element} - The rendered dialog box component.
 */
const ResumeDownloaded = ({ onClose, handleContinueExternalApplication, isSubmitting }) => {

  return (
    <Box>
      <Stack justifyContent={'center'}>
        <Box sx={{ textAlign: 'center' }} mb={3}>
          <Typography className="title" mb={1}>
            Resume Downloaded
          </Typography>
          <Typography className="info-text">
            Now you can proceed to the external platform & complete your application with the downloaded
            application. All the best.
          </Typography>
        </Box>
        <Stack direction={{ xs: 'column-reverse', md: 'row' }} alignItems={'center'} spacing={2.5}>
          <Button fullWidth variant="outlined" size="medium" onClick={onClose}>
            Do It Later
          </Button>
          <Button
            fullWidth
            variant="contained"
            size="medium"
            onClick={handleContinueExternalApplication}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'In-progress...' : 'Continue with application'}
          </Button>
        </Stack>
      </Stack>
    </Box>
  )
}

export default ResumeDownloaded;
